import(/* webpackMode: "eager", webpackExports: ["abTestingFunction"] */ "/app/src/helpers/abTesting.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["sendEventToAnalyticsFn"] */ "/app/src/helpers/analytics.ts");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/hooks/estonia.ts");
;
import(/* webpackMode: "eager", webpackExports: ["ExternalMainScripts"] */ "/app/src/modules/client/wrappers/ExternalMainScripts/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/components/skeletons/LobbySliderSkeleton.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useAuthCookies.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useInfoProject.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/common/hooks/useLicenseScript.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/deposit/hooks/useABIncreasePrevDep.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/deposit/hooks/useErrorsNotifications.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/googleAnalytics/hooks/useConfigGAHook.ts");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/BonanzaPromoDashboardContent/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/BonanzaPromoSnackbar/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/ClockUTC/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/CmsFaq/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/CmsHowToParticipate/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/FortuneWheelPage/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/components/PromotionsPage/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useBonanzaPromo"] */ "/app/src/modules/promotions/hooks/useBonanzaPromo.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/modules/promotions/hooks/usePromotionsMenuData.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useServer"] */ "/app/src/modules/server/context/ServerEnvContext.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/store/StoreClient.ts");
